/**
 * Eksport wyniku zapytania: CSV (separator `;` — polski Excel) i TSV do schowka
 * (wklejenie do Excela trafia w komórki). NULL → pusta komórka.
 */

import type { DbQueryResult } from './types';

function csvCell(v: string | null): string {
  if (v === null) return '';
  return /[";\n\r]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}

export function toCsv(result: Pick<DbQueryResult, 'columns' | 'rows'>): string {
  const header = result.columns.map((c) => csvCell(c.name)).join(';');
  const body = result.rows.map((r) => r.map(csvCell).join(';'));
  return [header, ...body].join('\r\n');
}

export function toTsv(result: Pick<DbQueryResult, 'columns' | 'rows'>): string {
  const clean = (v: string | null) => (v ?? '').replace(/[\t\r\n]+/g, ' ');
  return [result.columns.map((c) => c.name), ...result.rows]
    .map((r) => (r as (string | null)[]).map(clean).join('\t'))
    .join('\n');
}
